var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 56,
      strokeMiterlimit: 10
    },
    d: "M421.97,933.31L192.5,643.16c0,0-11.24-32.01,12.03-56.54c0,0,18.92-19.15,57.26-9.85L379.11,711.1 c0,0,16.4,14.33,18.62-18.15l-4.55-449.33c0,0,0.84-46.9,48.65-53.76c0,0,47.86-10.32,62.01,47.83l12.81,308 c0,0-3.98,17.23,37.39,17.33l216.53,7.84c0,0,89.44,0.28,56.26,128.78L756.7,933.4L421.97,933.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 56,
      strokeMiterlimit: 10
    },
    d: "M394.54,376.8l-1.36-133.99c0,0,0.84-46.9,48.65-53.76c0,0,47.86-10.32,62.01,47.83l5.75,138.23 c70.18-20.17,120.44-74.35,120.44-138.03c0-80.89-81.08-146.46-181.1-146.46s-181.1,65.57-181.1,146.46 C267.82,302.63,321.09,358.12,394.54,376.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPress);
export default __webpack_public_path__ + "static/media/icon-press.e2e2cc5027000f63a8926fa7fb5247bd.svg";
export { ForwardRef as ReactComponent };